import { createPortal } from 'react-dom';
// Style
import styles from './MessageList.module.css';

/**
 * MessageList component.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
function MessageList({ children }) {
  return createPortal(
    <div className={styles.list}>
      {children}
    </div>,
    document.body,
  );
}

export default MessageList;
